module.exports = __webpack_public_path__ + "assets/070361b090f8d6c065e243f415252c18.png";